import { defineField, defineType } from 'sanity'
import { PageBlockTypes } from '../pageBlocks'

export default defineType({
  title: 'Before Countdown Content',
  name: 'beforeCountdown',
  type: 'object',
  fields: [
    defineField({
      title: 'Countdown Teaser',
      name: 'countdownTeaser',
      type: 'countdownTeaser',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: PageBlockTypes,
    }),
  ],
})